import React, { FunctionComponent } from 'react';
import classNames from 'classnames';

import { Enum } from '../../common/types';

export const CKBannerVariant = Enum(
  'default',
  'warning',
  'error',
  'special',
  'info'
);

export type CKBannerVariant = Enum<typeof CKBannerVariant>;

export interface CKBannerProps {
  variant?: CKBannerVariant;
  heading?: string | React.ReactNode;
  description?: string | React.ReactNode;
  cta?: React.ReactNode;
  icon?: React.ReactNode;
  timestamp?: string | React.ReactNode;
  isFullWidth?: boolean;
}

export const CKBanner: FunctionComponent<CKBannerProps> = ({
  variant = CKBannerVariant.default,
  heading,
  description,
  cta,
  icon,
  timestamp,
  isFullWidth,
}) => {
  const bannerClass = classNames(`ck-banner`, `ck-banner--${variant}`, {
    'ck-banner--full-width': isFullWidth,
  });
  return (
    <div
      className={bannerClass}
      style={{
        paddingTop: heading ? '.75rem' : '.25rem',
        paddingBottom: heading ? '.75rem' : '.25rem',
      }}
    >
      {icon && <div className="ck-banner-icon">{icon}</div>}
      <div className="ck-banner-body">
        <div>
          {heading && <div className="ck-banner--heading">{heading}</div>}
          <div className="ck-banner--description">{description}</div>
        </div>
        <div className="ck-banner-meta">
          {timestamp && <div className="ck-banner--timestamp">{timestamp}</div>}
          {cta && <div className="ck-banner--cta">{cta}</div>}
        </div>
      </div>
    </div>
  );
};
